
import PageLayout from "@/layouts/PageLayout";
import { BackgroundGradient } from "@/components/ui/background-gradient";

const PrivacyPage = () => {
  return (
    <PageLayout>
      <BackgroundGradient className="py-16 px-6 flex-grow" variant="subtle">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-display font-medium mb-8">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-muted-foreground">
              Last Updated: June 1, 2025
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Introduction</h2>
            <p>
              At cheqbooq, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, 
              disclose, and safeguard your information when you use our website or services. Please read this 
              Privacy Policy carefully. By accessing or using our services, you acknowledge that you have read, 
              understood, and agree to be bound by all terms of this Privacy Policy.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Information We Collect</h2>
            <p>
              We may collect information in several ways:
            </p>
            <ul>
              <li>
                <strong>Personal Data:</strong> When you pledge or register for our services, we may ask for your name, 
                email address, and other contact details.
              </li>
              <li>
                <strong>Financial Information:</strong> When our platform launches, we may collect 
                information about your financial accounts and transactions only with your explicit consent and through secure, encrypted connections.
              </li>
              <li>
                <strong>Usage Data:</strong> We automatically collect certain information when you visit our website, 
                including your browser type, IP address, device information, and pages visited.
              </li>
              <li>
                <strong>Communications:</strong> We collect information when you communicate with us, 
                including support inquiries and feedback.
              </li>
            </ul>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">How We Use Your Information</h2>
            <p>
              We use the information we collect for the following purposes:
            </p>
            <ul>
              <li>Providing, maintaining, and improving our services</li>
              <li>Processing pledges and managing your account</li>
              <li>Communicating with you about our services, updates, and important announcements</li>
              <li>Analyzing usage patterns to enhance user experience</li>
              <li>Protecting against fraud and ensuring platform security</li>
              <li>Complying with applicable legal obligations</li>
            </ul>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect your information 
              from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission 
              over the Internet or electronic storage is completely secure, and we cannot guarantee absolute security.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Your Rights</h2>
            <p>
              You may have various rights regarding your personal information, including:
            </p>
            <ul>
              <li>The right to access personal information we hold about you</li>
              <li>The right to request correction of inaccurate information</li>
              <li>The right to request deletion of your information</li>
              <li>The right to restrict or object to processing of your information</li>
              <li>The right to data portability</li>
            </ul>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Changes to This Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify you of any material changes by posting 
              the new Privacy Policy on this page and updating the "Last Updated" date.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at privacy@cheqbooq.com.
            </p>
          </div>
        </div>
      </BackgroundGradient>
    </PageLayout>
  );
};

export default PrivacyPage;
